import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { FirebaseService } from 'src/app/services/firebase.service';
import { PoliticaPrivacidadModalComponent } from '../politica-privacidad-modal/politica-privacidad-modal.component';

@Component({
  selector: 'app-empresa',
  templateUrl: './empresa.component.html',
  styleUrls: ['./empresa.component.scss']
})
export class EmpresaComponent implements OnInit {

  formDatos: FormGroup;
  formPlan: FormGroup;
  linear = true;

  planes = [
    {
      nombre: 'Mensual',
      precio: 50
    },
    {
      nombre: 'Semestral',
      precio: 250
    },
    {
      nombre: 'Anual',
      precio: 480
    },
  ];

  vehiculos = [
    'Tracto',
    'Furgón',
    'Camión',
    'Cisterna',
    'Bombonas',
    'Buses',
    'Otros'
  ];

  cantidades = [
    'De 1 a 5',
    'De 6 a 10',
    'De 11 a 20',
    'De 20 a más'
  ];

  cotizacion;
  precio: number;
  nombre = '';
  deshabilitado: boolean;

  constructor(
    private fb: FormBuilder,
    private fs: FirebaseService,
    private afs: AngularFirestore,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.formDatos = this.fb.group({
      nombre: ['', Validators.required],
      apellidos: ['', Validators.required],
      ruc: [ '', [Validators.required, Validators.pattern('[0-9]*'), Validators.minLength(11), Validators.maxLength(11)]],
      email: ['', [Validators.required, Validators.email]],
      celular: [ '', [Validators.required, Validators.pattern('[0-9]*'), Validators.minLength(9), Validators.maxLength(9)]],
      // whatsApp: [false],
      acepta: [false, Validators.requiredTrue],
      fechaCreacion: [firebase.firestore.Timestamp.fromDate(new Date())],
    });

    this.formPlan = this.fb.group({
      tipoPlan: [this.planes[0], Validators.required],
      tipoVehiculo: ['', Validators.required],
      cantidad: ['', Validators.required]
    });

    // this.formPlan.get('tipoPlan').valueChanges.subscribe( (res) => {
    //     this.nombre = res.nombre;
    //     console.log(this.nombre);
    // });



    this.cotizacion = this.afs.collection('cotizacionesPersonaNatural').ref.doc();
    console.log(this.cotizacion.id);
  }

  onSubmit() {
    if (this.formDatos.valid) {
      this.guardarCotizacion();
      this.deshabilitado = true;
    } else {
      this.validateAllFormFields(this.formDatos);
      this.deshabilitado = false;
    }
  }

  guardarCotizacion() {
    // const cotizacion = this.afs.collection('cotizacionesPersonaNatural').ref.doc().id;
    // console.log(cotizacion.id);
    this.fs.addCotizacionEmpresa(this.cotizacion.id, this.formDatos.value, this.formPlan.value)
    .then(() => {
      this.router.navigate([`/cotizar/empresa/${this.cotizacion.id}/gracias`]);
    }, error => console.error('error al enviar el formulario:', error));
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  openModalTerminos() {
    const dialogRef = this.dialog.open(PoliticaPrivacidadModalComponent, {
      panelClass: 'myModalPrivacidad'
    });
    dialogRef.afterClosed().subscribe();
  }

  errorNombre() {
    return this.formDatos.controls.nombre.hasError('required') ? 'Ingrese su nombre' : '';
  }

  errorApellidos() {
    return this.formDatos.controls.apellidos.hasError('required') ? 'Ingrese sus apellidos' : '';
  }

  errorRuc() {
    return this.formDatos.controls.ruc.hasError('required') ? 'Ingrese el RUC' :
    this.formDatos.controls.ruc.hasError('pattern') ? 'Solo se admiten números' :
    this.formDatos.controls.ruc.hasError('minlength') ? 'Debe contener 11 dígitos' :
    this.formDatos.controls.ruc.hasError('maxlength') ? 'No debe exceder los 11 dígitos' : '';
  }

  errorEmail() {
    return this.formDatos.controls.email.hasError('required') ? 'El email es necesario' :
    this.formDatos.controls.email.hasError('email') ? 'Ingresa un email válido' : '';
  }

  errorCelular() {
    return this.formDatos.controls.celular.hasError('required') ? 'Ingrese un número de celular' :
    this.formDatos.controls.celular.hasError('pattern') ? 'Solo se admiten números' :
    this.formDatos.controls.celular.hasError('minlength') ? 'Debe contener 9 dígitos' :
    this.formDatos.controls.celular.hasError('maxlength') ? 'No debe exceder los 9 dígitos' : '';
  }

  errorAcepta() {
    return this.formDatos.controls.acepta.hasError('required') ? 'Es necesario aceptar este campo' : '';
  }

  errorTipoVehiculo() {
    return this.formPlan.controls.tipoVehiculo.hasError('required') ? 'Seleccione un tipo' : '';
  }

  errorCantidad() {
    return this.formPlan.controls.cantidad.hasError('required') ? 'Seleccione una cantidad' : '';
  }

  errorTipoPlan() {
    return this.formPlan.controls.tipoPlan.hasError('required') ? 'Seleccionar' : '';
  }

}
